import Vue from 'vue'
import Router from 'vue-router'
import AssignmentTermsDashboard from '@/components/AssignmentTermsDashboard'
import AffiliatedGroupsList from '@/components/AffiliatedGroupsList'
import AssignmentTermsExport from '@/components/AssignmentTermsExport'
import ProductCoverageExport from '@/components/ProductCoverageExport'
import RemainingContingentsExport from '@/components/RemainingContingentsExport'
import AffiliatedGroupDetails from '@/components/AffiliatedGroupDetails'
import VendorDetails from '@/components/VendorDetails'
import ContractDetails from '@/components/ContractDetails'
import Login from '@/components/login'
import InsufficientPermissionsPage from '@/components/InsufficientPermissionsPage'
import store from '@/store'
import AssignmentTermOptions from '@/components/AssignmentTermOptions'
import AssignmentTermsList from '@/components/AssignmentTermsList'
import OptionIdsMaintenance from '@/components/AdminPanel/OptionIdsMaintenance'
import ZipcodesManagement from '@/components/AdminPanel/ZipcodesManagement'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'AssignmentTermsDashboard',
      component: AssignmentTermsDashboard,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true },
      props: (route) => ({
        vendorId: route.query.vendorId,
        productId: route.query.productId
      })
    },
    {
      path: '/vendors/:vendorId/products/:productId/assignment_terms',
      name: 'AssignmentTermsList',
      component: AssignmentTermsList,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/affiliated_groups',
      name: 'AffiliatedGroups',
      component: AffiliatedGroupsList,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/assignment_terms_export',
      name: 'AssignmentTermsExport',
      component: AssignmentTermsExport,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/coverage_export',
      name: 'ProductCoverageExport',
      component: ProductCoverageExport,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/remaining_contingents_export',
      name: 'RemainingContingentsExport',
      component: RemainingContingentsExport,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/affiliated_groups/:id',
      name: 'AffiliatedGroupDetails',
      component: AffiliatedGroupDetails,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/vendors/:id',
      name: 'VendorDetails',
      component: VendorDetails,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/vendors/:vendor_id/contracts/:uuid',
      name: 'ContractDetails',
      component: ContractDetails,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
      meta: { requiresAuth: false }
    },
    {
      path: '/no_access',
      name: 'InsufficientPermissionsPage',
      component: InsufficientPermissionsPage,
      beforeEnter: ifNotAuthenticated,
      meta: { requiresAuth: false }
    },
    {
      path: '/vendors/:vendorId/products/:productId/assignment_terms/:id/options',
      name: 'Options',
      component: AssignmentTermOptions,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/option_ids',
      name: 'OptionIdsAdminPanel',
      component: OptionIdsMaintenance,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/zipcodes',
      name: 'ZipcodesManagement',
      component: ZipcodesManagement,
      beforeEnter: ifAuthenticated,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Set the destination path in local storage so that it can be retrieved after authentication to redirect the user back to the original requested path
  if (to.meta.requiresAuth) {
    localStorage.setItem('redirectPath', to.fullPath)
  }

  document.title = to.name
  next()
})

// It's a temporary solution, we'll get rid of it in a couple of months.
// The problem is that we changed our routes, but ViD still have a lot of old links
// in their calendar.
router.beforeEach((to, from, next) => {
  if (to.name === 'AssignmentTermsDashboard' && to.query.productId !== undefined && to.query.vendorId !== undefined) {
    const path = `/vendors/${to.query.vendorId}/products/${to.query.productId}/assignment_terms`
    next(path)
  } else {
    next()
  }
})

export default router
